export default defineNuxtPlugin(() => {
  const { user, workspace } = useAuth()

  const bugsnag = useBugsnag()

  bugsnag.addOnError((event) => {
    // add user information to the error
    if (user.value) {
      event.setUser(user.value.id, user.value.attributes.email)
      if (workspace.value) {
        event.addMetadata('workspace', {
          id: workspace.value.id,
          displayName: workspace.value.attributes.displayName,
        })
      }
    }
  })
})
